import http from '../../../../http/base';
import { API_PATHS } from '../../../../http/configs';

export function getMemberLegalContractInfo(memberIdGuid) {
    return http.get(API_PATHS.getMemberLegalContractInfo, { params: { memberIdGuid } });
}

export function createMemberLegalContract(memberLegalContract) {
    return http.post(API_PATHS.resignMemberLegalContract, memberLegalContract);
}